import { goodsReceivedNote as goodsReceivedNoteEn } from '../en/goodsReceivedNote';

export const goodsReceivedNote = {
  ...goodsReceivedNoteEn,
  goodsReceivedNotes: 'භාණ්ඩ ලැබුණු සටහන්',
  allGoodsReceivedNotes: 'සියලුම භාණ්ඩ ලැබුණු සටහන්',
  createGoodsReceivedNote: 'භාණ්ඩ ලැබුණු සටහනක් සාදන්න',
  goodsReceivedNoteDetails: 'භාණ්ඩ ලැබුණු සටහනේ විස්තර',
  status_received: 'ලැබී ඇත',
  status_cancelled: 'අවලංගු කරන ලදී',
  viewAndManageAllGoodsReceivedNotes: "සියලුම භාණ්ඩ ලැබුණු සටහන් බලන්න සහ කළමනාකරණය කරන්න",
  createGoodsReceivedNoteDescription: "මිලදී ගැනීමේ ඇණවුමකට එරෙහිව ලැබුණු භාණ්ඩ සටහන් කරන්න",
  grnNumber: "GRN අංකය",
  purchaseOrderNumber: "මිලදී ගැනීමේ ඇණවුම",
  supplier: "සැපයුම්කරු",
  warehouse: "ගබඩාව",
  receivedAt: "ලැබුණු දිනය",
  receivedBy: "ලබාගත්තේ",
  createdAt: "සාදන ලද දිනය",
  status: "තත්ත්වය",
  actions: "ක්‍රියා",
  item: "අයිතමය",
  details: "GRN විස්තර",
  itemsToReceive: "ලැබිය යුතු අයිතම",
  itemsReceived: "ලැබුණු අයිතම",
  orderedQty: "ඇණවුම් කළ ප්‍රමාණය",
  remainingQty: "ඉතිරි ප්‍රමාණය",
  quantityReceived: "ලැබුණු ප්‍රමාණය",
  unitsSelected: "ඒකක තෝරා ඇත",
  lookupPurchaseOrder: "මිලදී ගැනීමේ ඇණවුම සොයන්න",
  purchaseOrderIdPlaceholder: "මිලදී ගැනීමේ ඇණවුම තෝරන්න",
  lookupButton: "සොයන්න",
  warehouseLabel: "ගබඩාව",
  atLeastOneItemRequired: "කරුණාකර ලැබීමට අවම වශයෙන් එක් අයිතමයක් තෝරන්න",
  selectWarehouse: "ගබඩාව තෝරන්න",
  supplierDeliveryReference: "සැපයුම්කරුගේ බෙදාහැරීමේ යොමුව",
  supplierDeliveryReferencePlaceholder: "සැපයුම්කරුගේ ඉන්වොයිසිය/බෙදාහැරීමේ පත්‍රිකා අංකය (විකල්ප)",
  notes: "සටහන්",
  notesPlaceholder: "මෙම ලැබීම ගැන සටහන් එක් කරන්න...",
  create: "භාණ්ඩ ලැබුණු සටහන සාදන්න",
  save: "සුරකින්න",
  cancelGoodsReceivedNote: "භාණ්ඩ ලැබුණු සටහන අවලංගු කරන්න",
  print: "මුද්‍රණය කරන්න",
  printGoodsReceivedNote: "භාණ්ඩ ලැබුණු සටහන මුද්‍රණය කරන්න",
  backToGoodsReceivedNotes: "භාණ්ඩ ලැබුණු සටහන් වෙත ආපසු",
  confirmCancel: "මෙම භාණ්ඩ ලැබුණු සටහන අවලංගු කිරීමට ඔබට විශ්වාසද? තොගය සහ මිලදී ගැනීමේ ඇණවුමේ ලැබුණු ප්‍රමාණය ආපසු හරවනු ඇත.",
  cancellationReason: "අවලංගු කිරීමට හේතුව",
  cancellationReasonPlaceholder: "අවලංගු කිරීමට හේතුව ඇතුළත් කරන්න...",
  filterByWarehouse: "ගබඩාව අනුව පෙරහන් කරන්න",
  filterByPurchaseOrder: "මිලදී ගැනීමේ ඇණවුම අනුව පෙරහන් කරන්න",
  dateFrom: "සිට",
  dateTo: "දක්වා",
  allWarehouses: "සියලුම ගබඩා",
  goodsReceivedNoteCreatedSuccess: "භාණ්ඩ ලැබුණු සටහන {number} සාර්ථකව සාදන ලදී",
  goodsReceivedNoteCancelledSuccessfully: "භාණ්ඩ ලැබුණු සටහන සාර්ථකව අවලංගු කරන ලදී",
  failedToCreateGoodsReceivedNote: "භාණ්ඩ ලැබුණු සටහන සෑදීමට අසමත් විය",
  failedToLoadGoodsReceivedNotes: "භාණ්ඩ ලැබුණු සටහන් පූරණය කිරීමට අසමත් විය",
  failedToLoadGoodsReceivedNote: "භාණ්ඩ ලැබුණු සටහන පූරණය කිරීමට අසමත් විය",
  failedToCancelGoodsReceivedNote: "භාණ්ඩ ලැබුණු සටහන අවලංගු කිරීමට අසමත් විය",
  someFieldsRequired: "ඉදිරිපත් කිරීමට පෙර ඉස්මතු කළ ක්ෂේත්‍ර නිවැරදි කරන්න",
  purchaseOrderRequired: "කරුණාකර මිලදී ගැනීමේ ඇණවුමක් තෝරන්න",
  warehouseRequired: "කරුණාකර ගබඩාවක් තෝරන්න",
  purchaseOrderNotFound: "මිලදී ගැනීමේ ඇණවුම හමු නොවීය",
  purchaseOrderCancelled: "අවලංගු කළ මිලදී ගැනීමේ ඇණවුමකට එරෙහිව භාණ්ඩ ලැබිය නොහැක",
  noGoodsReceivedNotesFound: "භාණ්ඩ ලැබුණු සටහන් හමු නොවීය",
  noGoodsReceivedNotesYet: "තවමත් භාණ්ඩ ලැබුණු සටහන් නැත.",
  noGoodsReceivedNotesFoundDescription: "ඔබගේ වත්මන් පෙරහන්වලට ගැළපෙන භාණ්ඩ ලැබුණු සටහන් නැත",
  noGoodsReceivedNotesYetDescription: "සැපයුම්කරුවෙකුගෙන් ලැබුණු බෙදාහැරීමක් සටහන් කිරීමට ඔබගේ පළමු භාණ්ඩ ලැබුණු සටහන සාදන්න.",
  createFirstGoodsReceivedNote: "පළමු භාණ්ඩ ලැබුණු සටහන සාදන්න",
  na: "නැත",
  searchPurchaseOrder: "මිලදී ගැනීමේ ඇණවුම් අංකය හෝ ID අනුව සොයන්න...",
  noOpenPurchaseOrders: "විවෘත මිලදී ගැනීමේ ඇණවුම් හමු නොවීය",
};
